import { Dispatch } from 'redux'
import {
	SUPPLYCHAINGRAPHDATA_ERROR,
	SUPPLYCHAINGRAPHDATA_LOADED,
	SUPPLYCHAINGRAPHDATA_LOADING,
} from '../slices/supplyChainGraphDataSlice'
import { NeoniApi } from '../../lib/api'
import { getApiErrorMessage } from '../../lib/utils'

export const getSupplierECO2eData =
	(api: NeoniApi, supplierIds: string = '') =>
	async (dispatch: Dispatch) => {
		dispatch({
			type: SUPPLYCHAINGRAPHDATA_LOADING,
		})
		try {
			const body = await api.get(`reports/highestEmissionSuppliers?` +
					new URLSearchParams({ supplierIds: supplierIds })
			)

			if (body.success === true) {
				// Successfully fetched suppliers graph data
				dispatch({
					type: SUPPLYCHAINGRAPHDATA_LOADED,
					payload: body.data.data,
				})
			} else {
				// Error
				dispatch({
					type: SUPPLYCHAINGRAPHDATA_ERROR,
					payload: getApiErrorMessage({ body }, 'Could not load supplier comparison data. Please try again.'),
				})
			}
		} catch (error) {
			dispatch({
				type: SUPPLYCHAINGRAPHDATA_ERROR,
				payload: getApiErrorMessage(error, 'Could not load supplier comparison data. Please try again.'),
			})
		}
	}
